import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ChevronUpIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.96967 4.46967C8.26256 4.17678 8.73744 4.17678 9.03033 4.46967L14.0303 9.46967C14.3232 9.76256 14.3232 10.2374 14.0303 10.5303C13.7374 10.8232 13.2626 10.8232 12.9697 10.5303L8.5 6.06066L4.03033 10.5303C3.73744 10.8232 3.26256 10.8232 2.96967 10.5303C2.67678 10.2374 2.67678 9.76256 2.96967 9.46967L7.96967 4.46967Z'
      />
    </SvgIcon>
  );
}
